<template>
  <el-dialog
    title="创建表单"
    :visible.sync="value.visible"
    width="500px"
    :destroy-on-close="true"
    append-to-body
    @open="onDlgOpen"
  >
    <div class="container ">
      <div class="has-bg-white border-radius-m border-a my-4 cursor-hand text-center flex-center" style="height: 180px;" @click="onClickItem('form')">
        <div>
          <div class="flex-center">
            <el-badge value="推荐" class="item">
              <div
                class="iconfont icon-file-text-fill"
                style="line-height:100%; font-size: 60px;"
              />
            </el-badge>
          </div>
          <div class="mt-4">
            从模板创建
          </div>
          <div class="mt-2 has-text-light">丰富的模板，一键复制</div>
        </div>
      </div>

      <div class="has-bg-white border-radius-m border-a my-4 cursor-hand text-center flex-center" style="height: 180px;" @click="onClickItem('new')">
        <div>
          <div class="flex-center">
            <div
              class="iconfont icon-file"
              style="line-height:100%; font-size: 60px;"
            /></div>
          <div class="mt-4">
            从空白创建
          </div>
          <div class="mt-2 has-text-light">从空白页面开始创建</div>
        </div>
      </div>
    </div>
    <!-- <div class="container ">
      <el-row :gutter="16" class="my-4">
        <el-col :span="12">
          <div class="has-bg-white border-radius-m border-a px-5 py-5 cursor-hand text-center flex-center" style="height: 210px;" @click="onClickItem('form')">
            <div>
              <div>
                <img src="https://bahuyun.com/bd-api/file/1207452866687008768" style="border-radius: 50%; width: 80px;">
              </div>
              <div class="mt-4">
                表单模板
              </div>
              <div class="mt-2 has-text-light">问卷调查、登记报名、信息收集</div>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="has-bg-white border-radius-m border-a px-5 py-5 cursor-hand text-center flex-center" style="height: 210px;" @click="onClickItem('test')">
            <div>
              <div>
                <img src="https://bahuyun.com/bd-api/file/1207452866695397376" style="border-radius: 50%; width: 80px;">
              </div>
              <div class="mt-4">
                测试模板
              </div>
              <div class="mt-2 has-text-light">在线考试、测评、考评等</div>
            </div>
          </div>
        </el-col>
      </el-row>

      <el-row :gutter="16" class="my-4">
        <el-col :span="12">
          <div class="has-bg-white border-radius-m border-a px-5 py-5 cursor-hand text-center flex-center" style="height: 210px;" @click="onClickItem('vote')">
            <div>
              <div>
                <img src="https://bahuyun.com/bd-api/file/1207453018537590784" style="border-radius: 50%; width: 80px;">
              </div>
              <div class="mt-4">
                投票模板
              </div>
              <div class="mt-2 has-text-light">评选、选举、投票</div>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="has-bg-white border-radius-m border-a px-5 py-5 cursor-hand text-center flex-center" style="height: 210px;" @click="onClickItem('order')">
            <div>
              <div>
                <img src="https://bahuyun.com/bd-api/file/1209789894690865152" style="border-radius: 50%; width: 80px;">
              </div>
              <div class="mt-4">
                订单模板
              </div>
              <div class="mt-2 has-text-light">订单、订购</div>
            </div>
          </div>
        </el-col>
      </el-row>

      <el-row :gutter="16" class="my-4">
        <el-col :span="12">
          <div class="has-bg-white border-radius-m border-a px-5 py-5 cursor-hand text-center flex-center" style="height: 210px;" @click="onClickItem('book')">
            <div>
              <div>
                <img src="https://bahuyun.com/bd-api/file/1207452867169353728" style="border-radius: 50%; width: 80px;">
              </div>
              <div class="mt-4">
                预约模板
              </div>
              <div class="mt-2 has-text-light">预约、预定</div>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="has-bg-white border-radius-m border-a px-5 py-5 cursor-hand text-center flex-center" style="height: 210px;" @click="onClickItem('new')">
            <div>
              <div class="flex-center">
                <div
                  class="iconfont icon-plus"
                  style="border-radius: 50%; width: 80px; height: 80px; line-height:80px; font-size: 40px;"
                /></div>
              <div class="mt-4">
                创建空白表单
              </div>
              <div class="mt-2 has-text-light">从空白页面开始创建</div>
            </div>
          </div>
        </el-col>
      </el-row>

    </div> -->

  </el-dialog>

</template>

<script>
import { openPage } from '@/utils/index'

export default {
  name: 'DlgCreateForm',
  components: {
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        visible: false
      })
    },
    params: {
      type: Object,
      default: () => ({
      })
    }
  },
  emits: ['ok', 'cancel'],
  data() {
    return {
    }
  },
  computed: {
  },
  watch: {
  },
  created() {
  },
  mounted() {
    console.log(this.value)
  },

  methods: {
    onDlgOpen() {
    },
    onClickItem(item) {
      this.value.visible = false

      if (item === 'new') {
        const workspaceId = localStorage.getItem('bd_webapp_orgId')
        openPage({
          name: 'FormCreate',
          query: { org_id: workspaceId }
        }, this)
      } else {
        openPage({
          name: 'TplList'
        }, this)
      }
    },
    onCancel() {
      console.log('cancel')
      this.value.visible = false
      this.$emit('cancel')
    },
    async onOk() {
      // const that = this
      console.log('ok')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped></style>
